module.exports = __webpack_public_path__ + "assets/img/small_spray_icon.57ba5a79.svg";